/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class ObjectIterator implements IterableIterator<[string, any]> {
  private readonly keys: string[];
  private readonly keyIterator: Iterator<string>;

  constructor(private source: object) {
    this.keys = source ? Object.keys(source) : [];
    this.keyIterator = this.keys[Symbol.iterator]();
  }

  next(): IteratorResult<[string, any]> {
    const keyResult = this.keyIterator.next();
    if (keyResult.done) {
      return { done: true, value: undefined };
    }
    const key = keyResult.value;
    return { done: false, value: [key, this.source[key]] };
  }

  [Symbol.iterator](): IterableIterator<[string, any]> {
    return this;
  }
}
